module.exports = __webpack_public_path__ + "media/images/flags/32/England-e149df283ed1c3e47517f3ad5ebd8323.png";